import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ModuleVersionConsumerRow } from "../types";

const ModuleVersionConsumersTableNameCell = ({
  item: consumer,
  ...cellProps
}: TableSimpleCellProps<ModuleVersionConsumerRow>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellLink href={`/stack/${consumer.id}`}>{consumer.name}</TableCellLink>
    </TableSimpleCell>
  );
};

export default ModuleVersionConsumersTableNameCell;
